import { OntarioObstetricalFileClickableTextContext } from "@/Common/Models/UI/ClickableTextContext";
import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";

class OntarioObstetricalFilePostnatalPhysicalExamResultState extends BaseOntarioObstetricalFileSubSection<BaseOntarioObstetricalFileSubSectionProps, never> {
    private readonly componentId = "PostnatalPhysicalExamResultState";

    public render(): JSX.Element {
        const physicalExam = this.props.form.Postnatal.PhysicalExamAsIndicated;

        return (
            <div className="row">
                <div className="col-md-4">
                    <div className="row row-form">
                        {this.renderRadioButtonField(
                            "AffectLabel",
                            this.controlRenderer.renderNormalAbnormalRadio(
                                physicalExam.AffectExam,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Postnatal.PhysicalExamAsIndicated.AffectExam = value),
                                "Postnatal_ExamAsIndicated_Affect"
                            ),
                            "col-md-4"
                        )}
                        {this.renderRadioButtonField(
                            "AbdomenLabel",
                            this.controlRenderer.renderNormalAbnormalRadio(
                                physicalExam.AbdomenExam,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Postnatal.PhysicalExamAsIndicated.AbdomenExam = value),
                                "Postnatal_ExamAsIndicated_Abdomen"
                            ),
                            "col-md-4"
                        )}
                        {this.renderRadioButtonField(
                            "ThyroidLabel",
                            this.controlRenderer.renderNormalAbnormalRadio(
                                physicalExam.ThyroidExam,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Postnatal.PhysicalExamAsIndicated.ThyroidExam = value),
                                "Postnatal_ExamAsIndicated_Tyroid"
                            ),
                            "col-md-4"
                        )}
                    </div>
                    <div className="row row-form">
                        {this.renderRadioButtonField(
                            "PerineumLabel",
                            this.controlRenderer.renderNormalAbnormalRadio(
                                physicalExam.PerineumExam,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Postnatal.PhysicalExamAsIndicated.PerineumExam = value),
                                "Postnatal_ExamAsIndicated_Perineum"
                            ),
                            "col-md-4"
                        )}
                        {this.renderRadioButtonField(
                            "BreastsLabel",
                            this.controlRenderer.renderNormalAbnormalRadio(
                                physicalExam.BreastsExam,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Postnatal.PhysicalExamAsIndicated.BreastsExam = value),
                                "Postnatal_ExamAsIndicated_Breasts"
                            ),
                            "col-md-4"
                        )}
                        {this.renderRadioButtonField(
                            "PelvicLabel",
                            this.controlRenderer.renderNormalAbnormalRadio(
                                physicalExam.PelvicExam,
                                value => this.props.mutateModelStateWithFormUpdate(s => s.Postnatal.PhysicalExamAsIndicated.PelvicExam = value),
                                "Postnatal_ExamAsIndicated_Pelvic"
                            ),
                            "col-md-4"
                        )}
                    </div>
                </div>
                <div className="col-md-8 margin-sm-top">
                    <p className="text-bold">{this.getString("CommentsLabel")}</p>
                    {this.controlRenderer.renderTextarea({
                        value: physicalExam.Comments,
                        onChange: value => this.props.mutateModelState(s => s.Postnatal.PhysicalExamAsIndicated.Comments = value),
                        id: this.componentId,
                        maxLength: 200,
                        maxRows: 4,
                        clickableTextOptions: this.getClickableTextOptions(this.componentId, OntarioObstetricalFileClickableTextContext.Postnatal_PhysicalExamIndicatedComment)
                    })}
                </div>
            </div>
        );
    }
}

export { OntarioObstetricalFilePostnatalPhysicalExamResultState };
